import ModuleBootstrapHelper from '../modules/ModuleBootstrapHelper';

export default class View {
	constructor(el) {
		// -- Properties
		//--------------------------------------------------------------
		this.dom = {
			el,
			body: $('body'),
			html: $('html'),
			page: $('html, body'),
			site: $('#site'),
			w: $(window),
		};

		this.dom.back = this.dom.site.find('.back-to-top');
		this.dom.language = this.dom.site.find('.languages.dropdown-menu');
	}

	init() {
		this.initBootstrapHelper();
		window.setResponsiveImage(this.breakpoint);

		// default bindings
		this.dom.w.on('orientationchange', () => {
			if (this.dom.w.scrollTop() < 30) {
				this.dom.page.animate(
					{
						scrollTop: 0,
					},
					0,
					() => {
						this.update(false);
					}
				);
			} else {
				this.update();
			}
		});

		this.dom.back.on('click', (e) => {
			e.preventDefault();
			this.backToTop();
		});

		this.manageAriaHiddenLangAndBackToTop();
	}

	initBootstrapHelper() {
		this.bootstrapHelper = new ModuleBootstrapHelper();
		this.breakpoint = this.bootstrapHelper.breakpoint;
		window.breakpoint = this.bootstrapHelper.breakpoint;
	}

	update(scrolled) {
		if (scrolled !== undefined) {
			if (scrolled) {
				this.dom.body.addClass('page-scrolled');
			} else {
				this.dom.body.removeClass('page-scrolled');
			}
		} else if (this.dom.w.scrollTop() > 5) {
			this.dom.body.addClass('page-scrolled');
		} else {
			this.dom.body.removeClass('page-scrolled');
		}
		this.manageAriaHiddenLangAndBackToTop();
	}

	manageAriaHiddenLangAndBackToTop() {
		if (this.dom.w.scrollTop() > 5) {
			this.dom.language.attr('aria-hidden', true);
			this.dom.back.attr('aria-hidden', false);
		} else {
			this.dom.language.attr('aria-hidden', false);
			this.dom.back.attr('aria-hidden', true);
		}
	}

	backToTop() {
		this.dom.page.animate({ scrollTop: 0 }, 500);
	}
}
